import React from "react";
import GlobalContext from "./../../GlobalContext";
import { Location } from "@reach/router";

const MiscSocialSmall = ({ useGlobalLink, color, extraClass, webLink, customOnOff, listSocialShow  }) => {
  // console.log(extraClass);
  const { facebookLink, twitterLink, linkedinLink, instagramLink, whatsappLink, siteURL} = React.useContext(GlobalContext);

  if (color === "notheme" || color === "black") {
    color = "var(--black)";
  } else if (color === "nature") {
    color = "var(--green2)";
  } else if (color === "cyborg") {
    color = "var(--purple)";
  } else if (color === "childhood") {
    color = "var(--pink)";
  } else if (color === "green") {
    color = "var(--primary)";
  }

  const isShow = (socialName) => {
    return listSocialShow?.includes(socialName.toLowerCase())
  }
  
  return (
    <Location>
      {({ location }) => {
        const myPath = encodeURI(siteURL + location.pathname);
        const webLinkText = webLink;
        const twitterLinkText = `https://twitter.com/intent/tweet?url=${myPath}`;
        const facebookLinkText = `https://www.facebook.com/sharer/sharer.php?u=${myPath}`;
        const linkedInLinkText = `https://www.linkedin.com/shareArticle?mini=true&url=${myPath}&title=&summary=&source=`;
        const whatsappLinkText = `https://api.whatsapp.com/send?text=${myPath}`;

        // console.log(twitterLinkText, "\n", twitterLink);

        return (
          <aside className={`socialicons ${extraClass ? extraClass : ""}`}>
            {(!useGlobalLink && !customOnOff) || (useGlobalLink && linkedinLink) || (customOnOff && isShow('linkedin')) ? (
              <a
                style={{ marginRight: "6px" }}
                id="linkedin"
                href={useGlobalLink ? linkedinLink : linkedInLinkText || linkedinLink || "https://www.linkedin.com"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width={32} height={32} fill="none" viewBox="0 0 32 32">
                  <path
                    fill={color || "#fff"}
                    d="M12.202 22h-2.97V11.978h2.97V22zm-1.486-11.395C9.765 10.605 9 9.793 9 8.803 9 7.803 9.774 7 10.716 7c.952 0 1.717.813 1.717 1.803.009.99-.765 1.802-1.717 1.802zM23.318 22h-2.961v-4.875c0-1.159-.018-2.662-1.539-2.662-1.547 0-1.779 1.27-1.779 2.578V22h-2.97V11.978h2.846v1.373h.036c.4-.784 1.37-1.616 2.81-1.616 3.006 0 3.557 2.074 3.557 4.773V22z"
                  />
                  <rect width={30.75} height={30.75} x={0.625} y={0.625} stroke={color || "#fff"} strokeWidth={1.25} rx={15.375} />
                </svg>
              </a>
            ) : null}

            {(!useGlobalLink && !customOnOff) || (useGlobalLink && twitterLink) || (customOnOff && isShow('twitter'))  ? (
              <a
                style={{ marginRight: "6px" }}
                id="twitter"
                href={useGlobalLink ? twitterLink : twitterLinkText || twitterLink || "https://www.twitter.com"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width={32} height={32} fill="none" viewBox="0 0 32 32">
                  <g transform="translate(9,9)">
                    <path
                      fill={color || "#fff"}
                      d="M8.33327 5.93367L13.5459 0H12.3111L7.78307 5.15107L4.1692 0H0L5.46607 7.79007L0 14.0117H1.2348L6.01347 8.5708L9.8308 14.0117H14M1.68047 0.911867H3.57747L12.3102 13.1446H10.4127"
                    />
                  </g>
                  <rect width={30.75} height={30.75} x={0.625} y={0.625} stroke={color || "#fff"} strokeWidth={1.25} rx={15.375} />
                </svg>
              </a>
            ) : null}

            {(!useGlobalLink && !customOnOff) || (useGlobalLink && facebookLink) || (customOnOff && isShow('facebook')) ? (
              <a
                id="facebook"
                href={useGlobalLink ? facebookLink : facebookLinkText || facebookLink || "https://www.facebook.com"}
                fill="transparent"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginRight: "6px" }}
              >
                <svg width={32} height={32} fill="none" viewBox="0 0 32 32">
                  <path
                    fill={color || "#fff"}
                    d="M17.089 25v-8.208h2.763l.418-3.2h-3.181v-2.04c0-.928.257-1.56 1.59-1.56h1.703V7.128C20.085 7.088 19.072 7 17.9 7c-2.45 0-4.129 1.488-4.129 4.232v2.36H11v3.2h2.771V25h3.318z"
                  />
                  <rect width={30.75} height={30.75} x={0.625} y={0.625} stroke={color || "#fff"} strokeWidth={1.25} rx={15.375} />
                </svg>
              </a>
            ) : null}

            {/* {!useGlobalLink || (useGlobalLink && instagramLink) ? ( */}
            {(!useGlobalLink && !customOnOff) || (useGlobalLink && instagramLink) || (customOnOff && isShow('instagram')) ? (
              <a
                id="instagram"
                href={instagramLink || "https://www.instagram.com"}
                fill="transparent"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginRight: "6px" }}
              >
                <svg width={32} height={32} fill="none" viewBox="0 0 32 32">
                  <g fill={color || "#fff"} clipPath="url(#clip0)">
                    <path d="M18.83 9h-5.66A4.176 4.176 0 009 13.17v5.66c0 2.3 1.871 4.17 4.17 4.17h5.66c2.3 0 4.17-1.87 4.17-4.17v-5.66C23 10.872 21.13 9 18.83 9zm2.762 9.83a2.763 2.763 0 01-2.763 2.762h-5.658a2.762 2.762 0 01-2.762-2.763v-5.658a2.761 2.761 0 012.762-2.762h5.658a2.762 2.762 0 012.763 2.762v5.658z" />
                    <path d="M16 12.379a3.624 3.624 0 00-3.62 3.62c0 1.998 1.623 3.622 3.62 3.622s3.621-1.624 3.621-3.621a3.624 3.624 0 00-3.62-3.621zm0 5.833a2.212 2.212 0 110-4.425 2.213 2.213 0 010 4.425zm3.628-4.938a.867.867 0 100-1.736.867.867 0 000 1.736z" />
                  </g>
                  <rect width={30.75} height={30.75} x={0.625} y={0.625} stroke={color || "#fff"} strokeWidth={1.25} rx={15.375} />
                  <defs>
                    <clipPath id="clip0">
                      <path fill={color || "#fff"} d="M0 0h14v14H0z" transform="translate(9 9)" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            ) : null}

            {(!useGlobalLink && !customOnOff) || (useGlobalLink && whatsappLink) || (customOnOff && isShow('whatsapp')) ? (
              <a
                id="facebook"
                href={useGlobalLink ? whatsappLink : whatsappLinkText || whatsappLink || "https://api.whatsapp.com/"}
                fill="transparent"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginRight: "6px" }}
              >
                <svg width={32} height={32} fill="none" viewBox="0 0 32 32">
                  <g clipPath="url(#clip0_12255_21488)" transform="translate(6,6)">
                    <path
                      d="M7.00376 2.33324C7.96672 1.92584 8.96673 1.70361 10.0408 1.70361C11.0778 1.70361 12.1149 1.92584 13.0778 2.33324C14.0408 2.74065 14.8556 3.29621 15.5593 3.99991C16.263 4.70361 16.8186 5.51843 17.226 6.48139C17.6334 7.44435 17.8556 8.44435 17.8556 9.51843C17.8556 10.5555 17.6334 11.5925 17.226 12.5555C16.8186 13.5184 16.263 14.3332 15.5593 15.0369C14.8556 15.7407 14.0408 16.2962 13.0778 16.7036C12.1149 17.111 11.1149 17.3332 10.0408 17.3332C8.70747 17.3332 7.44821 16.9999 6.26302 16.3703L1.92969 17.7407L3.3371 13.5555C2.59635 12.3332 2.22598 10.9999 2.22598 9.51843C2.22598 8.48139 2.44821 7.44435 2.85561 6.48139C3.26302 5.51843 3.81858 4.70361 4.52228 3.99991C5.18895 3.29621 6.0408 2.77769 7.00376 2.33324ZM10.0038 15.9999C10.8927 15.9999 11.7075 15.8147 12.5223 15.4814C13.3371 15.1481 14.0038 14.6666 14.5964 14.111C15.1889 13.5555 15.6334 12.8518 15.9667 12.0369C16.3001 11.2221 16.4852 10.4073 16.4852 9.51843C16.4852 8.62954 16.3001 7.81472 15.9667 6.99991C15.6334 6.18509 15.1519 5.51843 14.5964 4.92584C14.0408 4.33324 13.3371 3.8888 12.5223 3.55547C11.7075 3.22213 10.8927 3.03695 10.0038 3.03695C9.11487 3.03695 8.30006 3.22213 7.48524 3.55547C6.67043 3.8888 6.00376 4.37028 5.41117 4.92584C4.81858 5.48139 4.37413 6.18509 4.0408 6.99991C3.70747 7.81472 3.52228 8.62954 3.52228 9.51843C3.52228 10.9258 3.92969 12.1851 4.7445 13.3332L3.92969 15.7407L6.44821 14.9629C7.52228 15.6666 8.7445 15.9999 10.0038 15.9999ZM11.5593 11.0369C11.8186 10.7036 12.0038 10.5184 12.1149 10.5184C12.1889 10.5184 12.5223 10.6666 13.1149 10.9629C13.7075 11.2592 14.0038 11.4444 14.0408 11.5184C14.0408 11.5555 14.0778 11.5925 14.0778 11.6666C14.0778 11.8888 14.0038 12.1481 13.8927 12.4444C13.7815 12.7036 13.5223 12.9258 13.1519 13.111C12.7815 13.2962 12.4112 13.3703 12.1149 13.3703C11.7075 13.3703 11.0778 13.1481 10.1519 12.7407C9.48524 12.4444 8.89265 12.0369 8.41117 11.5184C7.92969 10.9999 7.41117 10.3703 6.89265 9.5925C6.41117 8.85176 6.15191 8.18509 6.15191 7.5925V7.51843C6.18895 6.8888 6.41117 6.33324 6.92969 5.8888C7.07784 5.74065 7.26302 5.66658 7.48524 5.66658C7.52228 5.66658 7.59635 5.66658 7.67043 5.66658C7.7445 5.66658 7.81858 5.66658 7.85561 5.66658C8.00376 5.66658 8.07784 5.70361 8.11487 5.74065C8.15191 5.77769 8.22598 5.8888 8.26302 6.03695C8.30006 6.18509 8.44821 6.48139 8.59635 6.96287C8.78154 7.44435 8.85561 7.70361 8.85561 7.74065C8.85561 7.8888 8.7445 8.07398 8.48524 8.33324C8.26302 8.5925 8.11487 8.74065 8.11487 8.81472C8.11487 8.85176 8.11487 8.92584 8.15191 8.96287C8.37413 9.48139 8.7445 9.92584 9.18895 10.3703C9.55932 10.7407 10.0778 11.074 10.7445 11.4073C10.8186 11.4444 10.8927 11.4814 10.9667 11.4814C11.1149 11.5184 11.3001 11.3703 11.5593 11.0369Z"
                      fill={color || "#fff"}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_12255_21488">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                  <rect width={30.75} height={30.75} x={0.625} y={0.625} stroke={color || "#fff"} strokeWidth={1.25} rx={15.375} />
                </svg>
              </a>
            ) : null}
          </aside>
        );
      }}
    </Location>
  );
};

export default MiscSocialSmall;
